module.exports = __webpack_public_path__ + "img/avatar_random_17.211102e1.png";